import i18next from 'i18next';
import { MarketCode } from '../@types/MarketCode';
import { getLanguage } from './market';
import { svSE, nbNO, enUS } from '../translation';

const i18n = (marketCode?: MarketCode) => {
  const locale = getLanguage(marketCode);

  i18next.init({
    lng: locale || 'en-US',
    fallbackLng: 'en-US',
    debug: true,
    resources: {
      'sv-SE': {
        translation: svSE,
      },
      'nb-NO': {
        translation: nbNO,
      },
      'en-US': {
        translation: enUS,
      },
    },
  });
};

export default i18n;
